// Redux Actions
import {
  SET_MB_STORE,
  ADD_MB_TYPE,
  REMOVE_MB_TYPE,
  SET_MB_PATH_CUSTOM,
} from "../types";

export function setMBStore(payload) {
  return { type: SET_MB_STORE, payload }
};

export function addMBType(id, category) {
  return { type: ADD_MB_TYPE, id, category }
};

export function removeMBType(id, category) {
  return { type: REMOVE_MB_TYPE, id, category }
};

export function setMBPathCustom(payload) {
  return { type: SET_MB_PATH_CUSTOM, payload }
};
